import { EditOutlined } from '@ant-design/icons';
import { type RootState } from '@reducers';
import { Col, Form, Input, Row } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { normalizeWarehouseProductName } from '../../fragments/normalize-warehouse-product-name';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { productAdd } from '../../reducers/products/reducer';
import { SPACING } from '../../theme/tokens';

interface IForm {
  name: string;
}

function ProductAdd({
  productDownloadedUUID = undefined,
}: {
  productDownloadedUUID?: string;
}): React.ReactElement {
  const dispatch = useAppDispatch();
  const productsInProcess = useSelector((s: RootState) => s.Products.inProcess);
  const languageType = useSelector((s: RootState) => s.Language.languageType);

  const [form] = Form.useForm<IForm>();

  return (
    <Form
      form={form}
      onFinish={({ name }: IForm): void => {
        if (!languageType) {
          return;
        }
        dispatch(
          productAdd(
            normalizeWarehouseProductName(name),
            languageType.code,
            productDownloadedUUID,
          ),
        );
      }}
    >
      <Row gutter={[SPACING.none, SPACING.xl]}>
        <Col span={8} offset={8} className="gutter-row">
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
              },
              {
                type: 'string',
                min: 3,
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Create new product with name"
              prefix={<EditOutlined />}
              type="string"
              disabled={productsInProcess}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default React.memo(ProductAdd);
